<template>
  <div>
    <page-header class="initiative-header" title="CTO Circle Terms Of Use" />
    <div class="container my-5">
      <p><strong>FOR END USERS</strong> July 2016</p>

      <p>
        Please read these terms of use (“Terms of Use”, “Agreement”) carefully.
        This is a legally binding agreement that governs your use of the CTO
        Circle Platform (“Service”) offered by MEQO Private Limited (“Company”,
        “we”, “us”).
      </p>

      <p>
        You may accept these Terms of Use by clicking to accept or agree where
        such an option is made available to you in any product, software,
        service, or website associated with the Service.
      </p>

      <p>
        You acknowledge that this Agreement is contractually binding, even if it
        is electronic and is not physically signed by either party.
      </p>

      <h3>1. The Service</h3>
      <p>
        The Service allows you to use an interactive community application
        (“Application”) created by the Company on behalf of a church or similar
        social organization (“Organization”). This Application may run on a
        variety of platforms (“Platforms”) including but not limited to iOS,
        Android, Windows, and Mac, as offered by the Company.
      </p>

      <h3>2. General Conduct</h3>
      <p>
        The Application is made available for your own, personal use. You must
        not use the Application for any commercial, illegal, or unauthorised
        purpose. When you use the Application, you must comply with the laws of
        Singapore, and any applicable international laws, including laws in your
        country of residence (together, “Applicable Laws”).
      </p>

      <p>
        You agree that when using the Application you will comply with all
        Applicable Laws and these Terms of Use. In particular, but without
        limitation, you agree not to:
      </p>

      <ol type="a">
        <li>
          Create user accounts by automated means or under false or fraudulent
          pretenses;
        </li>
        <li>Impersonate other persons;</li>
        <li>
          Scrape or collect information about other Users in an automated
          fashion or for any purpose other than your participation in the
          Organization community
        </li>
        <li>Harass or otherwise offend other Users</li>
        <li>Reverse engineer any code associated with the Service</li>
        <li>
          Intentionally attempt to damage, collapse, or overload our servers
        </li>
        <li>
          Use the Application in any unlawful manner or in a manner which
          promotes or encourages illegal activity including (without limitation)
          copyright infringement
        </li>
      </ol>

      <p>
        You agree to indemnify the Company and the Organization against any
        loss, damage, costs or expenses which they suffer or incur directly or
        indirectly as a result of your use of the Application otherwise than in
        accordance with these Terms or Applicable Laws.
      </p>

      <h3>3. Trademarks</h3>
      <p>
        The trademarks, service marks, and logos (“Trade Marks“) contained on or
        in the Application are owned by the Company, the Organization, or their
        third party partners. You cannot use, copy, edit, vary, reproduce,
        publish, display, distribute, store, transmit, commercially exploit or
        disseminate the Trade Marks without the prior written consent of the
        Company, the Organization or the relevant third party.
      </p>

      <h3>4. Third Party Content</h3>
      <p>
        Users of the Application may post links to third party content (“Third
        Party Content”) through normal use of the Service. You acknowledge that
        neither the Company nor the Organization monitor or have any control
        over any Third Party Content, and therefore neither the Company nor the
        Organization make any guarantee as to its accuracy or completeness, or
        accept any responsibility whatsoever for its content. You acknowledge
        that by accessing Third Party Content, you may be exposed to content
        that you may find offensive, indecent, or objectionable, and you do so
        at your own risk.
      </p>

      <h3>5. Feedback</h3>
      <p>
        If you provide us with any feature requests, comments, suggestions or
        other feedback ("Feedback"), you agree that such Feedback is provided on
        a non-proprietary and non-confidential basis, and grant us a perpetual,
        non-exclusive, worldwide, fully paid-up, irrevocable license to
        incorporate, disclose, and use without limitation the Feedback for any
        purpose.
      </p>

      <h3>6. Service Suspension</h3>
      <p>
        The Company reserves the right to suspend or cease providing any
        services relating to the Application, with or without notice, and shall
        have no liability or responsibility to you if it chooses to do so.
      </p>

      <h3>7. Personal Data</h3>
      <p>
        In order to make full use of the Service, you may wish to create an
        account, and provide us with certain information (“Personal Data”),
        including but not limited to your name and profile picture(“Profile
        Information”), your email address, and phone number (“Contact
        Information”), and any other personal information you choose to provide
        (“Further Information”). Our use of your Personal Data is outlined more
        fully in our Privacy Policy, which you should carefully review.
      </p>

      <p>
        You may amend your Personal Information at any time, either through
        mechanisms provided in the Application, or by emailing
        privacy@ctocircle.com.
      </p>
      <p>
        The Company will implement commercially reasonable safeguards to protect
        your Personal Data, and will not provide your Personal Data to any third
        parties, aside from other Users of the Service as detailed in the
        Privacy Policy, or where required to do so by law.
      </p>

      <h3>8. User Content</h3>
      <p>
        The Service allows you to post content (“Content”) in the Application.
        By posting Content, you grant the Company and the Organization a
        perpetual, irrevocable, worldwide, royalty-free, freely transferable and
        sublicensable (through unlimited levels of sublicense) non-exclusive
        right to create derivative works of, use, reproduce, modify, transmit,
        publish, publicly display and distribute such Content and derivative
        work. You represent and warrant that:
      </p>

      <ol type="a">
        <li>
          you own and control all of the rights to the Content that you post or
          you otherwise have the right to post such Content and to grant the
          rights granted herein;
        </li>
        <li>the Content is accurate and not misleading; and</li>
        <li>
          distribution of the Content you supply in accordance with your
          direction does not violate these Terms of Use and will not violate any
          rights of or cause injury to any person or entity.
        </li>
      </ol>

      <p>
        You hereby waive any moral rights you may have in such Content under the
        laws of any jurisdiction. We may (but are not obligated to) display your
        Content, including your actual name.
      </p>

      <h3>9. Content Backup and Security</h3>
      <p>
        Although the Company will make commercially reasonable efforts to
        securely store any Content you create, you acknowledge that neither the
        Company nor the Organization provide any warranty whatsoever on the
        security or reliability of that Content, and that you should therefore
        save any Content to alternative storage solutions. Neither the Company
        nor the Organization will be liable for any breach or loss of Content.
      </p>

      <h3>10. Content Copyright</h3>
      <p>
        You agree that you will not post any Content that is offensive or in
        violation of the intellectual property rights of others. Officers of the
        Company or the Organization may remove any Content which, at either
        party’s discretion:
      </p>

      <ol>
        <li>infringes the intellectual property of others;</li>
        <li>violates these Terms of Use;</li>
        <li>is illegal;</li>
        <li>is irrelevant, junk, or spam;</li>
        <li>is otherwise objectionable</li>
      </ol>

      <p>
        In accordance with applicable copyright legislation, the Company will,
        in appropriate circumstances and at the Company's sole discretion,
        terminate access to those who are deemed to be repeat infringers and
        provide your Personal Information to relevant authorities or copyright
        holders where required to do so by law.
      </p>

      <h3>11. Media Content</h3>
      <p>
        The Service permits you to upload images, videos, audio files, and other
        files ("Media Content") which may be accessed by other Users. Officers
        of the Company or the Organization may remove any Media Content at any
        time, for any reason.
      </p>

      <p>
        The Company may attempt to screen Media Content for viruses and harmful
        components, but we do not represent or warrant that Media Content will
        be free of viruses or other harmful components. We strongly advise you
        to install and use industry-leading virus protection software.
      </p>

      <h3>12. Child Protection</h3>
      <p>
        You may not use the Service if you are under 13 years of age. If we
        discover that you are under 13, we will immediately deactivate your
        account, and endeavour to delete your Personal Information and any
        Content you have shared.
      </p>
      <p>
        If you are aged 13 to 18, you should obtain permission from your parents
        or guardians to use the Service, and advise them to direct any questions
        or concerns they might have to support@ctocircle.com.
      </p>

      <h3>13. Termination</h3>
      <p>
        You may terminate this Agreement at any time simply by deactivating your
        account, and deleting any copies of the Application that you have
        installed.
      </p>
      <p>
        We may terminate this Agreement at any time, with or without cause.<br />
        Terminating shall not relieve either party of the obligations and/or
        restrictions stated herein.
      </p>

      <h3>14. Revisions to these Terms</h3>
      <p>
        We may change these Terms of Use at anytime, at our sole discretion. The
        latest version will be always be posted on our website. Your continued
        use of the Service constitutes acceptance of any such modifications;
        therefore you should frequently review these Terms of Use to understand
        the conditions that apply to your use of the Service. If you do not
        agree to the amended terms, you should stop using the Service.
      </p>

      <h3>15. Warranty</h3>
      <p>
        The Service is provided on an "as is" and "as available" basis without
        warranties of any kind, either express or implied. The Company disclaims
        all warranties, express or implied, including, without limitation,
        implied warranties of merchantability, fitness for a particular purpose,
        title and non- infringement as to the information, content, or
        materials.
      </p>
      <p>
        The Company does not represent that materials, including information
        available through the Service are accurate, complete, reliable, current,
        or errorfree. The Company does not represent or warrant that the
        services or its servers are free of viruses or other harmful components.
        The Company is not responsible for errors or omissions in any
        information or materials accessed through the Service.
      </p>
      <p>
        While the Company attempts to make your access or use of the Service
        safe, the Company cannot and does not represent or warrant that the
        services or its server(s), or any content or materials are free of
        viruses or other harmful components; therefore you should use industry
        recognized software to detect and neutralize viruses, spyware, malware,
        and other harmful or otherwise undesirable components from any download.
      </p>

      <h3>16. Indemnification</h3>
      <p>
        You agree to defend, indemnify and hold harmless the Company, the
        Organization, and any of their corporate affiliates, independent
        contractors, service providers and consultants, and each of their
        respective directors, employees and agents, from and against any claims,
        damages, costs, liabilities and expenses (including, but not limited to,
        reasonable attorneys' fees) arising out of or related to any Content you
        post or your use of or inability to use the Services, including without
        limitation any actual or threatened suit, demand or claim arising out of
        or relating to the Content, your conduct, your violation of these Terms
        of Use or your violation of the rights of any third party.
      </p>

      <h3>17. Limitation of Liability</h3>
      <p>
        In no event shall the Company, the Organization, or any of their
        corporate affiliates, independent contractors, service providers or
        consultants, or any of their respective directors, employees and agents,
        be liable for any special, indirect or consequential damages, including
        but not limited to, loss of use, loss of profits or loss of data,
        whether in an action in contract, tort (including but not limited to
        negligence) or otherwise, arising out of or in any way related to or
        connected with the use of the Service, the Content or the materials
        contained in or accessed through the Service, including without
        limitation any damages, loss or injury caused by or resulting from
        reliance on any information obtained from the Company, or that result
        from mistakes, omissions, interruptions, deletion of files or email,
        errors, defects, viruses, delays in operation or transmission or any
        failure of performance, whether or not resulting from acts of God,
        communication failure, theft, destruction, or unauthorized access to the
        Company's records, programs or services.
      </p>

      <p>
        The aggregate liability of the Company, whether in contract, warranty,
        tort (including negligence, whether active, passive, or imputed),
        product liability, strict liability or other theory, arising out of or
        relating in any manner to the use of the Service, shall not exceed any
        fees you have paid, if any, to the Company for access to or use of the
        Service, for the 3 calendar months prior. If no fees have been paid, the
        aggregate liability of the Company shall not exceed S$10. The Company
        makes no warranties regarding the security or reliability of the
        Service.
      </p>

      <h3>18. Arbitration</h3>
      <p>
        Any dispute arising out of or in connection with this contract,
        including any question regarding its existence, validity or termination,
        shall be referred to and finally resolved by arbitration administered by
        the Singapore International Arbitration Centre ("SIAC") in accordance
        with the Arbitration Rules of the Singapore International Arbitration
        Centre ("SIAC Rules") for the time being in force, which rules are
        deemed to be incorporated by reference in this clause. The seat of the
        arbitration shall be Singapore, the Tribunal shall consist of one
        arbitrator, and the language of the arbitration shall be English.
      </p>

      <h3>19. Applicable Law and Venue</h3>
      <p>
        This Agreement and any controversy arising out of or relating to this
        Agreement shall be governed by and construed in accordance with the laws
        of the Republic of Singapore, without regard to conflict of law
        principles. Each party agrees to submit to the exclusive jurisdiction of
        the competent courts in Singapore, in any action arising out of a
        dispute under or in connection with this Agreement or any transaction
        contemplated by this Agreement.
      </p>

      <h3>20. International Nature of Communication</h3>
      <p>
        You acknowledge that in using the Service you will be causing
        communications to be sent through international telecommunications
        networks. Even communications that seem to be domestic in nature can
        result in the transmission of international communications regardless of
        where you are physically located at the time of transmission. You
        acknowledge that use of the Service results in international data
        transmissions.
      </p>

      <h3>21. Successors and Assigns</h3>
      <p>
        All the terms and provisions of this Agreement shall be binding upon and
        inure to the benefit of and be enforceable by the respective parties
        hereto and their permitted successors and assigns.
      </p>

      <h3>22. Severability</h3>
      <p>
        If any of these Terms of Use should be determined to be invalid, illegal
        or unenforceable for any reason by any court of competent jurisdiction
        then such term shall be enforced only to the extent it is enforceable
        and the remaining terms shall survive and remain in full force and
        effect and continue to be binding and enforceable.
      </p>

      <h3>23. Relationship</h3>
      <p>
        You agree that no joint venture, partnership, employment, or agency
        relationship exists between you and the Company.
      </p>

      <h3>24. Waiver</h3>
      <p>
        No waiver of any term, provision or condition of this Agreement, whether
        by conduct or otherwise, in any one or more instances, shall be deemed
        to be, or shall constitute, a waiver of any other term, provision or
        condition hereof, whether or not similar, nor shall such waiver
        constitute a continuing waiver of any such term, provision r condition
        hereof. No waiver shall be binding unless executed in writing by the
        party making the waiver.
      </p>

      <h3>25. Force Majeure</h3>
      <p>
        If the performance of any part of this Agreement by either party is
        prevented, hindered, delayed or otherwise made impracticable by reason
        of any flood, riot, fire, judicial or governmental action, labor
        disputes, act of God or any other causes beyond the control of either
        party, that party shall be excused from such to the extent that it is
        prevented, hindered or delayed by such causes.
      </p>

      <h3>26. Entire Agreement</h3>
      <p>
        This Agreement and Privacy Policy, constitutes the complete and
        exclusive statement of the agreement between the parties with respect to
        the use of this site and any acts or omissions of the Company and
        supersedes any and all prior or contemporaneous communications,
        representations, statements and understandings, whether oral or written,
        between the parties.
      </p>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/global/PageHeader';
export default {
  components: {
    PageHeader,
  },
};
</script>

<style scoped>
</style>